import { Component, ChangeDetectorRef } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import type { DialogComponentI } from '@recruitee/user-interface';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogRef,
  HeadingComponent,
} from '@recruitee/user-interface';

export type DialogResult = {
  createJob: boolean;
};

export type RequisitionApprovedDialogData = {
  canCreateJob: boolean;
  hasAccessToJob: boolean;
  requisitionName: string;
  offerSlug: string | null;
};

@Component({
  selector: 'rt-requisition-approved-success-dialog',
  templateUrl: './requisition-approved-success-dialog.component.html',
  imports: [
    ButtonComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    HeadingComponent,
    RouterModule,
    TranslatePipe,
  ],
})
export class RequisitionApprovedSuccessDialogComponent
  implements DialogComponentI<RequisitionApprovedDialogData, DialogResult>
{
  public readonly imageSrc = 'assets/images/requisitions/approved.svg';
  public canCreateJob: boolean;
  public requisitionName: string;
  public isJobAlreadyCreated: boolean;
  public hasAccessToJob: boolean;
  public offerSlug: string | null;

  constructor(
    private dialogRef: DialogRef,
    private cdRef: ChangeDetectorRef,
  ) {}

  public close() {
    this.dialogRef.close();
  }

  public createJob() {
    this.dialogRef.close({ createJob: true });
  }

  public setDialogData(data: RequisitionApprovedDialogData, triggerUpdate: boolean): void {
    this.canCreateJob = data.canCreateJob;
    this.requisitionName = data.requisitionName;
    this.isJobAlreadyCreated = !!data.offerSlug;
    this.hasAccessToJob = data.hasAccessToJob;
    this.offerSlug = data.offerSlug;
    this.cdRef.detectChanges();
  }
}
